(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[994],{

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 2084:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bar-and-restaurant",
      function () {
        return __webpack_require__(6975);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const BreadCrumbSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "About Us",
                            "item": "https://www.hoteltwintowers.com/about-us"
                        },
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Room and Suits",
                            "item": "https://www.hoteltwintowers.com/hotel-room-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": "Bar and Restaurant",
                            "item": "https://www.hoteltwintowers.com/bar-and-restaurant"
                        },
                        {
                            "@type": "ListItem",
                            "position": 4,
                            "name": "Events",
                            "item": "https://www.hoteltwintowers.com/#events"
                        },
                        {
                            "@type": "ListItem",
                            "position": 5,
                            "name": "Banquet Halls in Shimla",
                            "item": "https://www.hoteltwintowers.com/banquet-halls-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 6,
                            "name": "Conference Halls",
                            "item": "https://www.hoteltwintowers.com/conference-hall"
                        }
                    ]
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbSchema);


/***/ }),

/***/ 5154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const RestaurantSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "Restaurant",
                    "servesCuisine": [
                        "Italian",
                        "Indian",
                        "Chinese"
                    ],
                    "logo": "https://www.hoteltwintowers.com/icons/header-logo.svg",
                    "image": "https://www.hoteltwintowers.com/images/restaurant-banner.png",
                    "priceRange": "",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "NH 05, New kufri, Galu, Hills,",
                        "addressLocality": "Shimla",
                        "addressRegion": "Indian Himalayan Region",
                        "postalCode": "171209",
                        "addressCountry": "India"
                    },
                    "name": "The Twin Towers Hotel",
                    "telephone": "+91 07807885113",
                    "email": "info@hoteltwintowers.com",
                    "url": "https://www.hoteltwintowers.com/bar-and-restaurant",
                    "hasMenu": "",
                    "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                    "containedInPlace": {
                        "@type": "Place",
                        "name": "The Twin Towers Hotel",
                        "url": "https://www.hoteltwintowers.com",
                        "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5"
                    }
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (RestaurantSchema);


/***/ }),

/***/ 6975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ RestaurantBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1027);
/* harmony import */ var _styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6066);
/* harmony import */ var _components_Restaurantgallery_Restaurantgallery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8368);
/* harmony import */ var _components_Contactusform_DiningPageForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(967);
/* harmony import */ var _components_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(678);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7294);
/* harmony import */ var _components_Schema_HotelSchema_restaurant_schema__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5154);
/* harmony import */ var _components_Schema_HotelSchema_breadcrumb__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9881);












function RestaurantBar() {
    const bannerImages = [
        {
            title: "A wonderful and smooth dining ",
            subheading: "experience awaits you",
            bannerImage: "/images/Gallery/restaurant-banner.jpg"
        },
        {
            title: "Relish delicious food and have a ",
            subheading: "fulfilling experience.",
            bannerImage: "/images/Gallery/res-banner2.jpg"
        },
        {
            title: "Enjoy hearty meal in a calm and ",
            subheading: "relaxing atmosphere.",
            bannerImage: "/images/Gallery/res-banner3.jpg"
        }
    ];
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false
    };
    // const accordionData = [
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    // ];
    // const [activeIndex, setActiveIndex] = useState(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Best Bar and Restaurants | The Twin Towers Hotel in Shimla"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Experience the unforgettable moments of Bar Club and Top Restaurant Shimla at The Twin Towers Hotel in Shimla with stunning views."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/bar-and-restaurant"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Best Hotels In Kufri best restaurants in Shimla Top Restaurants Shimla bar club best places to eat in Shimla best bars in Shimla best Indian restaurants in Shimla"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "d-none",
                children: "A Wonderful Bar Club and Restaurants Shimla"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_4__["default"], {
                ...settings,
                className: "banner_slider",
                children: bannerImages.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().restaurant_banner),
                            style: {
                                backgroundImage: "url(".concat(item.bannerImage, ")")
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().banner_text),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().banner_text_con), " common_title"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                children: item.subheading
                                            })
                                        ]
                                    })
                                })
                            })
                        }, index)
                    }, index))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().restaurant), " common_padding"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().restaurant_top), " row"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().res_top_left), " col-md-6 col-sm-12 common_title"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().center_div), " col-md-8"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: "Restaurant"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "One of the best restaurant in Kufri, where there is something delicious for everyone at our restaurant. Guests may choose from a wide variety of options offering anything from traditional Indian cuisine to international. The home-style meal, which is always made with a local flair, will help you stay healthy throughout your whole trip. Moreover, it allows you to sample some of the regional specialties."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "/contact-us",
                                                className: "secound_common_btn",
                                                children: "Make Reservation"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().res_top_right), " col-md-6 col-sm-12"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/images/restaurant.jpg",
                                        alt: "Restaurant Image"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().restaurant_top_two), " row"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().res_top_left_two), " col-md-6 col-sm-12"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/images/bar.jpg",
                                        alt: "Restaurant Image"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().res_top_right_two), " col-md-6 col-sm-12 common_title"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_11___default().center_div), " col-md-8"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: "Bar"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "Relax and replenish with drinks from the Bar, which has a wide range of mocktails and cocktails made with premium ingredients which makes it the best bar in Kufri. Drink one of our cold beverages, which include fresh juices and other options, to satisfy your thirst. Indulge in some quality time with your loved ones here."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "/contact-us",
                                                className: "secound_common_btn",
                                                children: "Make Reservation"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Restaurantgallery_Restaurantgallery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Schema_HotelSchema_restaurant_schema__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Schema_HotelSchema_breadcrumb__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ }),

/***/ 5828:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,4661,8115,9774,2888,179], function() { return __webpack_exec__(2084); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);